import { translateIpfsToPinata } from './translate-ipfs-uri.util';

const translateDate = (dateValue: any): Date => {
  if (typeof dateValue === 'number') {
    return new Date(dateValue * 1000);
  }
  return new Date(dateValue);
};

export const translateMetadata = (metadataRaw: string) => {
  const parsedJsonMetadata = JSON.parse(metadataRaw);
  return {
    title: parsedJsonMetadata.title,
    description: parsedJsonMetadata.description,
    author: parsedJsonMetadata.properties?.author?.description,
    totalSupply: parsedJsonMetadata.properties?.total_supply?.description,
    issueNumber: parsedJsonMetadata.properties?.issue_number?.description,
    issueDate:
      parsedJsonMetadata.properties?.issue_date &&
      translateDate(
        parsedJsonMetadata.properties?.issue_date.description,
      ).toUTCString(),
    collection: parsedJsonMetadata.properties?.collection?.description,
    animationImage: translateIpfsToPinata(parsedJsonMetadata.image),
    previewImage: translateIpfsToPinata(parsedJsonMetadata.image),
    videoUrl: translateIpfsToPinata(parsedJsonMetadata.image),
  };
};
